module.exports = __webpack_public_path__ + "img/1595067384.6643dfed.jpg";